import { createBrowserRouter } from "react-router";
import { RootLayout } from "@shared/components/layout/RootLayout";
import Home from "./routes/home";
import ServicesPage from "./routes/services";
import AboutPage from "./routes/about";
import HowItWorksPage from "./routes/how-it-works";
import ContactPage from "./routes/contact";
import { HireOSRedirect } from "./components/HireOSRedirect";
import TermsPage from "./routes/terms";
import ContractorTermsPage from "./routes/contractor-terms";
import PrivacyPage from "./routes/privacy";
import NotFoundPage from "./routes/not-found";

/**
 * Public-frontend route config.
 *
 * Most public routes render inside RootLayout, which supplies the shared
 * Header + Footer chrome. The contact form lands in #79; the legal pages
 * and the generic result page land in #80.
 *
 * The token-gated, email-link pages (#84 approve, #85 payments, the
 * generic result page, and the feedback form) render OUTSIDE RootLayout —
 * no shared chrome. Their legacy Next.js layout.tsx files explicitly hid
 * the global Header/Footer, so they are registered as top-level routes
 * here to match production.
 */
export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/services",
        element: <ServicesPage />,
      },
      {
        path: "/about",
        element: <AboutPage />,
      },
      {
        path: "/how-it-works",
        element: <HowItWorksPage />,
      },
      {
        path: "/contact",
        element: <ContactPage />,
      },
      {
        path: "/terms",
        element: <TermsPage />,
      },
      {
        path: "/contractor-terms",
        element: <ContractorTermsPage />,
      },
      {
        path: "/privacy",
        element: <PrivacyPage />,
      },
      {
        // Catch-all 404 — inside RootLayout so it keeps Header/Footer.
        path: "*",
        element: <NotFoundPage />,
      },
    ],
  },
  // Token / post-action pages — chrome-less, registered outside RootLayout.
  // Their legacy Next.js layout.tsx files explicitly hid the global
  // Header/Footer: #84 approve, #85 payments, the generic result page,
  // and the token-gated feedback form (legacy feedback/layout.tsx).
  {
    path: "/result",
    element: <HireOSRedirect path="/result" />,
  },
  {
    path: "/feedback",
    element: <HireOSRedirect path="/feedback" />,
  },
  {
    path: "/approve",
    element: <HireOSRedirect path="/approve" />,
  },
  {
    path: "/pay-deposit",
    element: <HireOSRedirect path="/pay-deposit" />,
  },
  {
    path: "/pay-balance",
    element: <HireOSRedirect path="/pay-balance" />,
  },
  {
    path: "/collect-balance",
    element: <HireOSRedirect path="/collect-balance" />,
  },
  {
    path: "/pay-contractor",
    element: <HireOSRedirect path="/pay-contractor" />,
  },
  {
    path: "/inquiry/*",
    element: <HireOSRedirect path="/inquiry" />,
  },
  {
    path: "/inquiry",
    element: <HireOSRedirect path="/inquiry" />,
  },
]);
